module.exports = __webpack_public_path__ + "static/media/coty_2022.5dad4b55.svg";